import axios from 'axios';
import { toast } from 'react-toastify';

import { getToken } from '../helpers/localstorage';

const API_URL = process.env.REACT_APP_API_URL;

const defaultConfig = {
  method: 'GET',
};

export const request = async (
  url,
  { method, body, headers } = defaultConfig,
  message,
  auth = true,
) => {
  const authHeaders = auth
    ? {
        Authorization: `Bearer ${getToken()}`,
        ...headers,
      }
    : {};

  try {
    const result = await fetch(`${API_URL}/${url}`, {
      method,
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
    });

    if (result.ok) {
      !!message && toast(message);
    } else {
      if (result.status !== 403) {
        //forbidden pages do not throw error toast
        const opts = {
          style: {
            background: '#ff5252',
          },
        };
        toast.error('The request has failed.', opts);
      }
    }

    return result.json();
  } catch (e) {
    console.log(e);
  }
};

export const avatarUpload = async (url, file) => {
  const authHeaders = {
    Authorization: `Bearer ${getToken()}`,
  };

  try {
    const formData = new FormData();
    formData.append('avatar', file);

    const result = await fetch(`${API_URL}/${url}/avatar`, {
      method: 'POST',
      body: formData,
      headers: {
        ...authHeaders,
      },
    });

    return await result.json();
  } catch (e) {
    console.log(e);
  }
};

export const fileUpload = async (
  url,
  files,
  type,
  isShared,
  onUploadProgress,
  message,
) => {
  const authHeaders = {
    Authorization: `Bearer ${getToken()}`,
  };

  try {
    const formData = new FormData();
    const name = files[0].name;

    files.forEach((f) => {
      formData.append(f.name, f);
    });

    const response = await axios({
      method: 'post',
      headers: {
        ...authHeaders,
      },
      data: formData,
      url: `${API_URL}/${url}/file_upload?type=${type}&name=${encodeURIComponent(
        name,
      )}&isShared=${isShared}`,
      onUploadProgress: (e) => onUploadProgress(e),
    });

    if (response.status === 201) {
      !!message && toast(message);
    } else {
      if (response.status !== 403) {
        //forbidden pages do not throw error toast
        const opts = {
          style: {
            background: '#ff5252',
          },
        };
        toast.error('The request has failed.', opts);
      }
    }

    return response.data;
  } catch (e) {
    console.log(e);
  }
};
